export interface PillsByGrade {
  name: string;
  grade: string;
  numberOfFeaturePills: number;
  featurePillStyle?: string;
  featurePillDisplayIcon?: boolean;
  numberOfHighlightPills?: number;
  highlightPillStyle?: string;
  highlightPillDisplayIcon?: boolean;
}

export const pillsToShowByGrade: PillsByGrade[] = [
  {
    name: 'Caravan: Saver',
    grade: 'SAV2',
    numberOfFeaturePills: 3,
  },
  {
    name: 'Caravan: Saver',
    grade: 'SAV3',
    numberOfFeaturePills: 3,
  },
  {
    name: 'Caravan: Bronze',
    grade: 'BRO2',
    numberOfFeaturePills: 4,
  },
  {
    name: 'Caravan: Bronze',
    grade: 'BRO3',
    numberOfFeaturePills: 4,
  },
  {
    name: 'Caravan: Bronze - Sea View',
    grade: 'BRS2',
    numberOfFeaturePills: 4,
  },
  {
    name: 'Caravan: Bronze - Sea View',
    grade: 'BRS3',
    numberOfFeaturePills: 4,
  },

  {
    name: 'Caravan: Bronze - Sea View',
    grade: 'BRS3',
    numberOfFeaturePills: 4,
  },
  {
    name: 'Caravan: Signature Lakeside',
    grade: 'SSL2',
    numberOfFeaturePills: 4,
    numberOfHighlightPills: 1,
    highlightPillStyle: 'signature',
    highlightPillDisplayIcon: true,
  },
  {
    name: 'Caravan: Signature Lakeside',
    grade: 'SSL3',
    numberOfFeaturePills: 4,
    numberOfHighlightPills: 1,
    highlightPillStyle: 'signature',
    highlightPillDisplayIcon: true,
  },
  {
    name: 'Caravan: Signature - Front Row Sea View',
    grade: 'SSS2',
    numberOfFeaturePills: 4,
    numberOfHighlightPills: 1,
    highlightPillStyle: 'signature',
    highlightPillDisplayIcon: true,
  },
  {
    name: 'Caravan: Signature - Front Row Sea View',
    grade: 'SSS3',
    numberOfFeaturePills: 4,
    numberOfHighlightPills: 1,
    highlightPillStyle: 'signature',
    highlightPillDisplayIcon: true,
  },
  {
    name: 'Caravan: Signature - Front Row Sea View',
    grade: 'SSG2',
    numberOfFeaturePills: 4,
    numberOfHighlightPills: 1,
    highlightPillStyle: 'signature',
    highlightPillDisplayIcon: true,
  },
  {
    name: 'Caravan: Silver',
    grade: 'SIL2',
    numberOfFeaturePills: 5,
  },
  {
    name: 'Caravan: Silver',
    grade: 'SIL3',
    numberOfFeaturePills: 5,
  },
  {
    name: 'Caravan: Gold',
    grade: 'GOL2',
    numberOfFeaturePills: 5,
  },
  {
    name: 'Caravan: Gold',
    grade: 'GOL3',
    numberOfFeaturePills: 5,
  },
  {
    name: 'Caravan: Signature Gold - Lakeside',
    grade: 'SSG3',
    numberOfFeaturePills: 4,
    numberOfHighlightPills: 1,
    highlightPillStyle: 'signature',
    highlightPillDisplayIcon: true,
  },
  {
    name: 'Lodge: Signature - Lakeside',
    grade: 'SLL2',
    numberOfFeaturePills: 4,
    numberOfHighlightPills: 1,
    highlightPillStyle: 'signature',
    highlightPillDisplayIcon: true,
  },
  {
    name: 'Lodge: Signature - Lakeside',
    grade: 'SLL3',
    numberOfFeaturePills: 4,
    numberOfHighlightPills: 1,
    highlightPillStyle: 'signature',
    highlightPillDisplayIcon: true,
  },
  {
    name: 'Lodge: Emerald',
    grade: 'EME2',
    numberOfFeaturePills: 5,
  },
  {
    name: 'Lodge: Emerald',
    grade: 'EME3',
    numberOfFeaturePills: 5,
  },
  {
    name: 'Lodge: Diamond',
    grade: 'DIA2',
    numberOfFeaturePills: 5,
  },
  {
    name: 'Lodge: Diamond',
    grade: 'DIA3',
    numberOfFeaturePills: 5,
  },
  {
    name: 'Lodge: Signature - Front Row/Sea View',
    grade: 'SLS2',
    numberOfFeaturePills: 4,
    numberOfHighlightPills: 1,
    highlightPillStyle: 'signature',
    highlightPillDisplayIcon: true,
  },
  {
    name: 'Lodge: Signature - Front Row/Sea View',
    grade: 'SLS3',
    numberOfFeaturePills: 4,
    numberOfHighlightPills: 1,
    highlightPillStyle: 'signature',
    highlightPillDisplayIcon: true,
  },
  {
    name: 'Apartment: Comfort',
    grade: 'AS26',
    numberOfFeaturePills: 3,
  },
  {
    name: 'Apartment: Comfort',
    grade: 'CG48',
    numberOfFeaturePills: 3,
  },
  {
    name: 'Apartment: Comfort with Veranda',
    grade: 'AX24',
    numberOfFeaturePills: 3,
  },
  {
    name: 'Apartment: Comfort with Veranda',
    grade: 'AG26',
    numberOfFeaturePills: 3,
  },
  {
    name: 'Apartment: Comfort Plus',
    grade: 'AG36',
    numberOfFeaturePills: 3,
  },
  {
    name: 'Apartment: Comfort Plus',
    grade: 'AG48',
    numberOfFeaturePills: 3,
  },
  {
    name: 'Apartment: Standard',
    grade: 'AS48',
    numberOfFeaturePills: 3,
  },
  {
    name: 'Chalet: Standard Chalet',
    grade: 'CS26',
    numberOfFeaturePills: 3,
  },
  {
    name: 'Chalet: Standard Chalet',
    grade: 'CE26',
    numberOfFeaturePills: 3,
  },
  {
    name: 'Chalet: Comfort Plus Chalet',
    grade: 'CG24',
    numberOfFeaturePills: 3,
  },
  {
    name: 'Chalet: Comfort Plus Chalet',
    grade: 'CG26',
    numberOfFeaturePills: 3,
  },
  {
    name: 'Chalet: Comfort Plus Chalet',
    grade: 'CG36',
    numberOfFeaturePills: 3,
  },
  {
    name: 'Chalet: Comfort Chalet with Decking',
    grade: 'CS2X',
    numberOfFeaturePills: 3,
  },
  {
    name: 'Glamping: Geo Dome',
    grade: 'GE2',
    numberOfFeaturePills: 3,
  },
  {
    name: 'Glamping: Glamping Yurt',
    grade: 'YU02',
    numberOfFeaturePills: 3,
  },
  {
    name: 'Glamping: Glamping Yurt',
    grade: 'YU04',
    numberOfFeaturePills: 3,
  },
  {
    name: 'Glamping: Safari Tent',
    grade: 'SF25',
    numberOfFeaturePills: 3,
  },
  {
    name: 'Deck House',
    grade: 'XH2',
    numberOfFeaturePills: 5,
  },
  {
    name: 'Deck House',
    grade: 'XH3',
    numberOfFeaturePills: 5,
  },
  {
    name: 'Pod',
    grade: 'HPO4',
    numberOfFeaturePills: 3,
  },
  {
    name: 'Pod',
    grade: 'HPO6',
    numberOfFeaturePills: 3,
  },
];
